import { Box, Button, Grid, IconButton, InputAdornment, Paper, TextField } from "@material-ui/core";
import { Close, Search } from "@material-ui/icons";
import MaterialTable from "material-table";
import React, { useCallback, useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { uploadImageFile } from "../../../../api/uploadApi";
import {
    deleteUserMobile,
    getAllUserMobile,
    getUserMobileById,
    registerUserMobile,
    updateUserMobile,
} from "../../../../api/userMobileApi";
import { encode } from "../../../../utils/crypt";
import { swalCondition } from "../../../../utils/swalHelper";
import FromUser from "./components/FormUserMobile";
import { initailUserMobileFormValues, initialTableOptions, tableColumns } from "./helpers/userMobileManagementOption";

function UserMobileManagement() {
    // ref
    const controllerRef = useRef(null);
    const tableRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [isOpenModalAdd, setIsOpenModalAdd] = useState(false);
    const [tableOptions, setTableOptions] = useState(initialTableOptions);
    const [isCreateMode, setIsCreateMode] = useState(false);
    const [initailFormValues, setInitailFormValues] = useState(initailUserMobileFormValues);
    const [searchFilter, setSearchFilter] = useState("");

    //fetch data
    const fetchData = useCallback(async query => {
        try {
            const queryParams = {
                page: query?.page + 1 || 1,
                limit: query?.pageSize || 10,
                search: query?.search || "",
                order: query?.orderBy?.field || "usersMobileId",
                direction: query?.orderBy?.field ? query?.orderDirection : "desc",
            };
            const res = await getAllUserMobile(queryParams, controllerRef.current?.signal);
            if (res) {
                setTableOptions(currentState => ({
                    ...currentState,
                    currentPage: query?.page,
                    pageSize: query?.pageSize || 10,
                    totalData: res?.pagination?.totalData || 0,
                    order: query?.orderBy?.field || "usersMobileId",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                }));
                return {
                    data: res?.data || [],
                    page: query?.page || 0,
                    totalCount: res?.pagination?.totalData || 0,
                };
            }
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        } catch (error) {
            console.dir(error);
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
    }, []);

    // set formik value
    const setUserFormValues = useCallback(user => {
        setInitailFormValues({
            hnNumber: user?.hnNumber || "",
            patientPlan: user?.patientPlan || "",
            usersMobileId: user?.usersMobileId || "",
            fullname: user?.fullname || "",
            email: user?.email || "",
            phoneNumber: user?.phoneNumber || "",
            createdAt: user?.createdAt || "",
            patientPlanObj: { value: user?.patientPlan, label: user?.patientPlan } || {},
            username: user?.username || "",
            password: "",
            images: [],
            imagePath: user?.imagePath,
        });
    }, []);

    // // clear formik value
    // const clearUserFormValues = useCallback(() => {
    //     setInitailFormValues(initailUserMobileFormValues);
    // }, []);

    // // open modal create form
    // const handleOpenCreateUserForm = useCallback(() => {
    //     clearUserFormValues();
    //     setIsCreateMode(true);
    //     setIsOpenModalAdd(true);
    // }, [clearUserFormValues]);

    // handle function Edit Data
    const handleEditUserMobile = useCallback(
        async user => {
            const res = await getUserMobileById(user?.usersMobileId, controllerRef.current?.signal);
            if (res) {
                setUserFormValues(res);
                setIsCreateMode(false);
                setIsOpenModalAdd(true);
            } else {
                setUserFormValues(user);
            }
        },
        [setUserFormValues],
    );

    // create user mobile logic
    const handleCreateUserMobile = useCallback(async user => {
        try {
            //encode password
            const encodedPassword = encode(user?.password);

            // upload image
            let imagePath = "";
            if (user?.images?.length) {
                const formData = new FormData();
                formData.append("image", user?.images[0]?.src);
                imagePath = await uploadImageFile(formData, controllerRef.current?.signal);
            }

            delete user?.images;

            // create user mobile
            const isCreateUser = await registerUserMobile(
                { ...user, password: encodedPassword, imagePath },
                controllerRef.current?.signal,
            );
            if (isCreateUser) {
                tableRef.current.onQueryChange();
                setIsOpenModalAdd(false);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // update user mobile logic
    const handleUpdateUserMobile = useCallback(async user => {
        try {
            // encode password
            let encodedPassword;
            if (user?.password) {
                encodedPassword = await encode(user?.password);
            }

            // upload image
            let imagePath = user?.imagePath;
            if (user?.images?.length) {
                const formData = new FormData();
                formData.append("image", user?.images[0]?.src);
                imagePath = await uploadImageFile(formData, controllerRef.current?.signal);
            }

            delete user?.images;

            //update user
            const isUpdateUser = await updateUserMobile(
                user?.usersMobileId,
                { ...user, password: encodedPassword, imagePath },
                controllerRef.current?.signal,
            );
            if (isUpdateUser) {
                tableRef.current.onQueryChange();
                setIsOpenModalAdd(false);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    const handleResetPin = useCallback(async id => {
        const isConfirm = await swalCondition('<div className="h3 t-text-primary">Are you reset PIN?</div>', "", {
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "YES",
            cancelButtonText: "NO",
        });
        if (isConfirm === true) {
            try {
                let encodedPIN;
                encodedPIN = await encode("000000"); // reset pin to 000000
                //update user
                const isUpdateUser = await updateUserMobile(id, { pin: encodedPIN }, controllerRef.current?.signal);
                if (isUpdateUser) {
                    tableRef.current.onQueryChange();
                    setIsOpenModalAdd(false);
                    swalCondition("Reset PIN Success", "Default PIN 000000", {
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonText: "OK",
                    });
                }
            } catch (error) {
                console.dir(error);
            }
        }
    }, []);

    // delete user mobile logic
    const handleDeleteUserMobile = useCallback(async user => {
        const isConfirm = await swalCondition('<div className="h3 t-text-primary">Are you delete?</div>', "", {
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "YES",
            cancelButtonText: "NO",
        });
        if (isConfirm === true) {
            const isDeleteUser = await deleteUserMobile(user?.usersMobileId, controllerRef.current?.signal);
            if (isDeleteUser) {
                tableRef.current.onQueryChange();
                setIsOpenModalAdd(false);
            }
        }
    }, []);

    // click serach filter
    const handleSearchFilter = useCallback(() => {
        tableRef.current.onQueryChange({ search: searchFilter });
    }, [searchFilter]);

    // clear filter
    const handleClearSearchFilter = useCallback(() => {
        setSearchFilter("");
        tableRef.current.onQueryChange({ search: "" });
    }, []);

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={7} className="mb-5 mb-lg-0">
                    <h1 className="t-text-primary text-center text-xl-left">User application Management</h1>
                </Grid>
                {/* {thisMenuPermission?.create && (
                    <Grid item xs={12} lg={5} className="mb-5 mb-lg-0">
                        <Grid container spacing={3} justify={"flex-end"}>
                            <Grid item xs={12} lg={5}>
                                <Button onClick={handleOpenCreateUserForm} className="btn t-btn-primary w-100">
                                    <Add className="mr-2" /> Create User
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )} */}

                {/* Data Table material */}
                <Grid item xs={12}>
                    <Paper>
                        <Box className="t-table-custom p-lg-10 p-5">
                            <Box className="mb-2" display="flex" justifyContent="flex-end" alignItems="center">
                                <TextField
                                    className="mr-2"
                                    type="text"
                                    size="small"
                                    variant="standard"
                                    placeholder="Search"
                                    value={searchFilter}
                                    onChange={e => setSearchFilter(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button className="btn t-btn-primary h-50 mr-2" onClick={handleSearchFilter}>
                                    Search
                                </Button>
                                <Button className="btn t-btn-primary h-50" onClick={handleClearSearchFilter}>
                                    Clear
                                </Button>
                            </Box>
                            <MaterialTable
                                tableRef={tableRef}
                                title=""
                                data={fetchData}
                                columns={tableColumns}
                                options={tableOptions}
                                actions={[
                                    {
                                        icon: "edit",
                                        iconProps: { style: { fontSize: 18 }, className: "action-edit" },
                                        tooltip: "Edit",
                                        onClick: (event, rowData) => {
                                            // Do save operation
                                            handleEditUserMobile(rowData);
                                        },
                                        hidden: !thisMenuPermission?.edit,
                                    },
                                    {
                                        icon: "delete",
                                        iconProps: { style: { fontSize: 18 }, className: "action-delete" },
                                        tooltip: "Delete",
                                        onClick: (event, rowData) => handleDeleteUserMobile(rowData),
                                        hidden: !thisMenuPermission?.delete,
                                    },
                                ]}
                                components={{
                                    Container: Box,
                                    Toolbar: props => null,
                                }}
                                onSearchChange={text => console.log(text)}
                            />
                        </Box>
                    </Paper>
                </Grid>

                {/* Modal Form */}
                <Grid item xs={12}>
                    <Modal show={isOpenModalAdd} size="lg" scrollable={true} onHide={() => setIsOpenModalAdd(false)}>
                        <Modal.Header>
                            <Modal.Title>{isCreateMode ? "Create User" : "Update User"}</Modal.Title>
                            <IconButton onClick={() => setIsOpenModalAdd(false)}>
                                <Close />
                            </IconButton>
                        </Modal.Header>
                        <Modal.Body>
                            <FromUser
                                onSubmit={isCreateMode ? handleCreateUserMobile : handleUpdateUserMobile}
                                onClose={() => setIsOpenModalAdd(false)}
                                onResetPin={handleResetPin}
                                isCreateMode={isCreateMode}
                                initailUserFormValues={initailFormValues}
                            />
                        </Modal.Body>
                    </Modal>
                </Grid>
            </Grid>
        </div>
    );
}

export default UserMobileManagement;
